import { httpClient } from "../http/httpClient";

export interface CustomerByCpfResponse {
  name: string;
  cpf: string;
  phone?: string;
  email: string;
  rg: {
    number: string;
    uf: string;
    org: string;
    date: string;
  };
  birthDate: string;
  address: {
    zipCode: string;
    state: string;
    city: string;
    neighborhood: string;
    street: string;
    number: string;
    complement: string;
  };
  available: {
    amount: number;
    isAutorized: boolean;
    isContacted: boolean;
    isArchived: boolean;
  };
  renda: number;
  diaRecebimento: string;
  ocupacaoId: string;
  maritalStatus: string;
  spouseName: string;
  motherName: string;
  placeOfBirth: {
    city: string;
    uf: string;
  };
  gender: string;
  referenceContact: {
    degree: string;
    name: string;
    phone: string;
  }[];
  createdAt: string;
  updatedAt: string;
  __v: number;
  isClient: boolean;
  id: string;
}

export async function customerCpf(cpf: string) {
  const { data } = await httpClient.get<CustomerByCpfResponse>(
    `/customer/${cpf}`,
  );
  return data;
}
